@if(!isGoogleUser){
<form class="multifactor__authentication">
  @if(dialogRef){
  <div class="app__close--icon mr-[15px] mt-[10px]">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
      <span class="material-icons relative">clear</span>
    </button>
  </div>
  } @if (multiFactorAuthStep1) {
  <h4 class="multifactor__authentication--title mt-[40px]">Set Up Two Factor Authentication</h4>
  } @if (multiFactorAuthStep2 || multiFactorAuthStep3) {
  <h4 class="multifactor__authentication--title mt-[40px]">Enter code</h4>
  } @if (multiFactorAuthStep2 || multiFactorAuthStep3) {
  <p class="multifactor__authentication--subtitle">
    Enter the 6-digit code that we sent to {{ hiddenPhoneNumber }} to finish <br />
    setting up two-factor authentication.
  </p>
  }
  <div class="flex justify-center mt-[40px]">
    <div>
      @if (multiFactorAuthStep1) {
      <form [formGroup]="profileForm">
        <div formGroupName="phone">
          <mat-form-field appearance="fill" class="login-signup-form-desing w-[431px] max-[767px]:w-full">
            <mat-label class="automtic-form-desing-lable">Select Country</mat-label>
            <mat-select formControlName="country" disableOptionCentering (selectionChange)="formatNumber()" required>
              @for (countryCode of countyCodes; track countryCode) {
              <mat-option [value]="countryCode.code">
                {{ countryCode.country }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div formGroupName="phone" class="mt-[10px]">
          <mat-form-field appearance="fill" class="login-signup-form-desing w-[431px] max-[767px]:w-full">
            <mat-label class="automtic-form-desing-lable"> Phone Number </mat-label>
            <input
              formControlName="number"
              type="tel"
              placeholder="Telephone"
              (input)="formatNumber()"
              [errorStateMatcher]="phoneErrorMatcher"
              matInput
              (keyup.enter)="verifyUserPhoneNumber()"
              required
            />
            @if (!phoneGroup.valid) {
            <mat-error> Valid Phone Number: {{ phoneHint }} </mat-error>
            }
            <mat-hint>{{ phoneHint }}</mat-hint>
          </mat-form-field>
        </div>
      </form>
      } @if (multiFactorAuthStep2 || multiFactorAuthStep3) {
      <div class="app__centered-item">
        <ng-otp-input
          (keyup.enter)="enableMFA()"
          (onInputChange)="onOtpChange($event)"
          [config]="{ length: 6, allowNumbersOnly: 'true' }"
        ></ng-otp-input>
      </div>
      } @if (multiFactorAuthStep2 && counter > 0 && !errCode$) {
      <p class="multifactor__authentication--counter mt-3">
        Code will expire in <b> {{ transform(counter) }} </b>
      </p>
      } @if (multiFactorAuthStep3 && !data.hasStep) {
      <p class="multifactor__authentication--code--verfication mt-3 text-[#1FB86E]">Verified successfully!</p>
      } @if (multiFactorAuthStep2 && errCode$) {
      <p class="multifactor__authentication--code--verfication mt-3 text-[#EB5757]" style="color: red">Incorrect code. Please re-enter.</p>
      } @if (multiFactorAuthStep1) {
      <div class="app__centered-item mt-5">
        <button
          style="width: 242px"
          [class]="
            !(phoneGroup.valid && this.profileForm.get('phone.number').valid) ? ' app__btn--disabled pointer-events-none' : 'app__btn--primary'
          "
          (click)="verifyUserPhoneNumber()"
        >
          Get One Time Password
        </button>
      </div>
      } @if (multiFactorAuthStep2) {
      <div class="app__centered-item mt-[-10px]">
        <div>
          <button
            style="width: 242px"
            [class]="
              !(verification_code_Data && verification_code_Data?.length == 6) ? ' app__btn--disabled pointer-events-none' : 'app__btn--primary'
            "
            (click)="enableMFA()"
          >
            Verify
          </button>
          <p class="multifactor__authentication--code--verfication mt-[-15px] text-[#18191cb3]">
            Did not receive code? <a (click)="verifyUserPhoneNumber()"> <strong class=" cursor-pointer"[ngClass]="transform(counter) === '00:00' ? 'text-[#25508E]' : 'text-[#888]'" > Resend </strong> </a>
          </p>
        </div>
      </div>
      }
      @if (verificationCompleted) {
        <div class="app__centered-item mx-[8em] my-[4em] flex flex-col items-center">
          <img src="assets/images/verify-circel-logo.svg" alt="check-circle" class="w-[130px] h-[85px]">
          <p class="multifactor__authentication--code--verfication mt-3 text-[#18191C]">SMS Two Factor Authentication successfully enabled.</p>
        </div>
      }
      @if (multiFactorAuthStep3) {
      <div class="app__centered-item mt-[-10px]" *ngIf="!fromSetup || (fromSetup && data.hasStep)">
        <button class="app__btn--primary" style="width: 242px" (click)="data.hasStep ? addProfilePicture() : closeDialog()">
          {{ data.hasStep ? 'Save and continue' : 'Finish' }}
        </button>
      </div>
      }
    </div>
  </div>
</form>
}@else{
  <div class="auth-card">
    <h2 style="font-family: Open Sans;
    font-weight: 700;
    font-size: 20px;
    line-height: 144%; color: #25508E; margin-bottom: 30px;">Two Factor<span class="text-weight-[500] text-[#53565B]"> Authentication</span></h2>
  
    <div class="card shadow-sm border-0 bg-white d-flex align-items-center px-[3em] py-[3em] pl-8 pr-3">
      <p class="font-semibold text-xl mb-6">Authenticated with <span class="text-[#25508E]">Google</span></p>
      <p class="text-[#53565B] "style="    font-family: Open Sans;
      font-weight: 500;
      font-size: 14px;
      line-height: 148%;
      letter-spacing: 0%;
      text-align: center;">
        This account was created utilizing the credentials for <strong>Google</strong>, so authentication
        settings should be managed within that application.
      </p>
  
      <div class="d-flex align-items-center border rounded mt-3"> 
        <div class="d-flex align-items-center p-2">
        <ngx-avatars
        size="35"
        src="{{ googleUser.profile }}"
        name="{{ googleUser.first_name  | titlecase }}"
        initialsSize="2"
        cornerRadius="50"
        [round]="false"
        ></ngx-avatars> 
        <span class="ml-2">{{ googleUser.email }}</span>
        </div>
        <img src="assets/images/google-logo2.svg" alt="Google" class="ml-7 " />
      </div>
    </div>
  </div>
  
}
